var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sign-list" },
    [
      _c("navTab", {
        attrs: { navTabArrType: "corpSignList", navTabVal: _vm.navTabVal },
        on: {
          "update:navTabVal": function($event) {
            _vm.navTabVal = $event
          },
          "update:nav-tab-val": function($event) {
            _vm.navTabVal = $event
          }
        }
      }),
      _vm.navTabVal === "corpMySign"
        ? [
            _c(
              "el-row",
              { staticClass: "row", attrs: { type: "flex" } },
              [
                _c("el-col", { attrs: { span: 2 } }),
                _c(
                  "el-col",
                  { attrs: { span: 5 } },
                  [
                    ["5", "6"].includes(_vm.$route.query.signStatus)
                      ? _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择审批类型",
                              size: "small"
                            },
                            model: {
                              value: _vm.selectType,
                              callback: function($$v) {
                                _vm.selectType = $$v
                              },
                              expression: "selectType"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "文件审批", value: 0 }
                            }),
                            _c("el-option", {
                              attrs: { label: "用印审批", value: 1 }
                            }),
                            _c("el-option", {
                              attrs: { label: "全部", value: "" }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 10 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "请选择", size: "small" },
                                model: {
                                  value: _vm.selectedParm,
                                  callback: function($$v) {
                                    _vm.selectedParm = $$v
                                  },
                                  expression: "selectedParm"
                                }
                              },
                              [
                                ["5", "6"].includes(_vm.$route.query.signStatus)
                                  ? [
                                      _c("el-option", {
                                        attrs: {
                                          label: "文件/印章名称",
                                          value: "fileName"
                                        }
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: "签署方/申请人",
                                          value: "userName"
                                        }
                                      })
                                    ]
                                  : [
                                      _c("el-option", {
                                        attrs: {
                                          label: "文件名称",
                                          value: "contractName"
                                        }
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: "签署方",
                                          value: "signatoryFullName"
                                        }
                                      })
                                    ]
                              ],
                              2
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c("el-input", {
                              attrs: { size: "small", placeholder: "查询内容" },
                              model: {
                                value: _vm.selectedParmInfo,
                                callback: function($$v) {
                                  _vm.selectedParmInfo = $$v
                                },
                                expression: "selectedParmInfo"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("el-col", { attrs: { span: 4 } }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "center",
                        "white-space": "nowrap"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "140px" },
                          attrs: { placeholder: "请选择", size: "small" },
                          model: {
                            value: _vm.selectedStatus,
                            callback: function($$v) {
                              _vm.selectedStatus = $$v
                            },
                            expression: "selectedStatus"
                          }
                        },
                        _vm._l(_vm.statusEnum, function(item, index) {
                          return _c("el-option", {
                            key: "status" + index,
                            attrs: { label: item.label, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ]),
                _c(
                  "el-col",
                  { attrs: { span: 5 } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "unset" },
                      attrs: {
                        type: "daterange",
                        "value-format": "yyyy-MM-dd",
                        "default-time": ["00:00:00", "23:59:59"],
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        size: "small"
                      },
                      model: {
                        value: _vm.datePikerArr,
                        callback: function($$v) {
                          _vm.datePikerArr = $$v
                        },
                        expression: "datePikerArr"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { staticClass: "text-right", attrs: { span: 3 } },
                  [
                    _c(
                      "el-row",
                      { attrs: { type: "flex" } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "small" },
                                on: { click: _vm.findScreenSign }
                              },
                              [_vm._v("查询")]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "small" },
                                on: { click: _vm.rest }
                              },
                              [_vm._v("重置")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                key: "signlist-" + _vm.$route.query.signStatus,
                ref: "dataList",
                staticClass: "data-list",
                staticStyle: { "min-height": "54vh" },
                attrs: {
                  data: _vm.tableList,
                  "tooltip-effect": "dark",
                  "expand-row-keys": _vm.expandKeys,
                  "row-key": function(row) {
                    return row.applyId || row.approval.applyId
                  },
                  "header-cell-style": {
                    background: "#f9f9f9",
                    color: "#333333",
                    fontWeight: "500"
                  }
                },
                on: {
                  "cell-mouse-enter": _vm.cellMouseEnter,
                  "cell-mouse-leave": _vm.cellMouseLeave,
                  "selection-change": _vm.handleSelectionChange
                }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    type: "selection",
                    selectable: _vm.isSelectable,
                    width: "55"
                  }
                }),
                [
                  _c("el-table-column", {
                    attrs: { label: "文件名称", "min-width": "300" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              ["5", "6"].includes(_vm.$route.query.signStatus)
                                ? [
                                    row.approval
                                      ? _c(
                                          "div",
                                          [
                                            !row.flowType
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "align-items": "center",
                                                        position: "relative",
                                                        "padding-top": "10px"
                                                      }
                                                    },
                                                    [
                                                      row.approval.files > 1
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "multiFile"
                                                            },
                                                            [_vm._v("多")]
                                                          )
                                                        : _vm._e(),
                                                      _c("corp-apply-name", {
                                                        attrs: {
                                                          applyType: "signList",
                                                          signInfo: {
                                                            fromDingTalk:
                                                              row.approval
                                                                .fromDingTalk ||
                                                              null,
                                                            signStatus:
                                                              row.approval
                                                                .signStatus,
                                                            selfSign:
                                                              row.approval
                                                                .selfSign,
                                                            selfApprove:
                                                              row.approval
                                                                .selfApprove,
                                                            signNo:
                                                              row.approval
                                                                .signNo,
                                                            contractName:
                                                              row.approval
                                                                .contractName,
                                                            applyNo:
                                                              row.approval
                                                                .applyNo,
                                                            approveId:
                                                              row.approval
                                                                .approveId,
                                                            multiFile:
                                                              row.approval
                                                                .multiFile,
                                                            aiCorpUserIdFlag:
                                                              row.approval
                                                                .aiCorpUserIdFlag
                                                          }
                                                        },
                                                        on: {
                                                          approvelInfo: function(
                                                            $event
                                                          ) {
                                                            return _vm.approvelInfo(
                                                              row.approval
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "textEllipsis"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "发起方：" +
                                                          _vm._s(
                                                            row.approval
                                                              .ebqUserName
                                                          )
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "textEllipsis"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      发起时间：" +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatDateHM"
                                                            )(
                                                              row.approval
                                                                .createTime
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                      _c(
                                                        "el-tooltip",
                                                        {
                                                          attrs: {
                                                            effect: "dark",
                                                            content:
                                                              "由钉钉发起的",
                                                            placement:
                                                              "bottom-start"
                                                          }
                                                        },
                                                        [
                                                          row.approval
                                                            .fromDingTalk &&
                                                          row.approval
                                                            .fromDingTalk ==
                                                            1 &&
                                                          !_vm.isInDingTalk
                                                            ? _c("img", {
                                                                attrs: {
                                                                  src:
                                                                    "/images/icon/dingIcon.png",
                                                                  alt: "钉钉",
                                                                  width: "20px"
                                                                }
                                                              })
                                                            : _vm._e()
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-tooltip",
                                                        {
                                                          attrs: {
                                                            effect: "dark",
                                                            content:
                                                              "由WEB端发起的",
                                                            placement:
                                                              "bottom-start"
                                                          }
                                                        },
                                                        [
                                                          !row.approval
                                                            .fromDingTalk &&
                                                          _vm.isInDingTalk
                                                            ? _c(
                                                                "el-tag",
                                                                {
                                                                  attrs: {
                                                                    type:
                                                                      "danger",
                                                                    size:
                                                                      "small"
                                                                  }
                                                                },
                                                                [_vm._v("WEB")]
                                                              )
                                                            : _vm._e()
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              : [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "seal_name_time",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.sealToApplyDetail(
                                                            row.approval
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "seal_name"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "seal_box"
                                                            },
                                                            [
                                                              _c("img", {
                                                                staticClass:
                                                                  "seal_img",
                                                                attrs: {
                                                                  src: _vm.fileOperShowFn(
                                                                    row.approval
                                                                      .imgPath
                                                                  ),
                                                                  onerror:
                                                                    "this.src='/images/defalutSign.png'"
                                                                }
                                                              })
                                                            ]
                                                          ),
                                                          [
                                                            _c(
                                                              "el-tooltip",
                                                              {
                                                                attrs: {
                                                                  effect:
                                                                    "dark",
                                                                  content:
                                                                    "由钉钉发起的",
                                                                  placement:
                                                                    "bottom-start"
                                                                }
                                                              },
                                                              [
                                                                row.approval
                                                                  .flowType ===
                                                                  3 &&
                                                                !_vm.isInDingTalk
                                                                  ? _c("img", {
                                                                      attrs: {
                                                                        src:
                                                                          "/images/icon/dingIcon.png",
                                                                        alt:
                                                                          "钉钉",
                                                                        width:
                                                                          "20px"
                                                                      }
                                                                    })
                                                                  : _vm._e()
                                                              ]
                                                            ),
                                                            _c(
                                                              "el-tooltip",
                                                              {
                                                                attrs: {
                                                                  effect:
                                                                    "dark",
                                                                  content:
                                                                    "由WEB端发起的",
                                                                  placement:
                                                                    "bottom-start"
                                                                }
                                                              },
                                                              [
                                                                _vm.isInDingTalk &&
                                                                !(
                                                                  row.approval
                                                                    .flowType ===
                                                                  3
                                                                )
                                                                  ? _c(
                                                                      "el-tag",
                                                                      {
                                                                        attrs: {
                                                                          type:
                                                                            "danger",
                                                                          size:
                                                                            "small"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "WEB"
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "seal_text"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "  " +
                                                                  _vm._s(
                                                                    row.approval
                                                                      .sealName
                                                                  )
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        2
                                                      ),
                                                      _c("p", [
                                                        _vm._v(
                                                          "用印文件：" +
                                                            _vm._s(
                                                              row.approval
                                                                .applyName
                                                            )
                                                        )
                                                      ]),
                                                      _c("span", [
                                                        _vm._v(
                                                          "发起时间：" +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatDateHM"
                                                              )(
                                                                row.approval
                                                                  .createTime
                                                              )
                                                            )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  ]
                                : [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "align-items": "center",
                                          position: "relative",
                                          "padding-top": "10px"
                                        }
                                      },
                                      [
                                        row.files > 1
                                          ? _c(
                                              "span",
                                              { staticClass: "multiFile" },
                                              [_vm._v("多")]
                                            )
                                          : _vm._e(),
                                        _c("corp-apply-name", {
                                          attrs: {
                                            applyType: "signList",
                                            signInfo: {
                                              fromDingTalk:
                                                row.fromDingTalk || null,
                                              signStatus: row.signStatus,
                                              selfSign: row.selfSign,
                                              selfApprove: row.selfApprove,
                                              signNo: row.signNo,
                                              contractName: row.contractName,
                                              applyNo: row.applyNo,
                                              approveId: row.approveId,
                                              multiFile: row.multiFile,
                                              aiCorpUserIdFlag:
                                                row.aiCorpUserIdFlag
                                            }
                                          },
                                          on: {
                                            approvelInfo: function($event) {
                                              return _vm.approvelInfo(row)
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("p", { staticClass: "textEllipsis" }, [
                                      _vm._v(
                                        "发起方：" + _vm._s(row.ebqUserName)
                                      )
                                    ]),
                                    _c(
                                      "p",
                                      { staticClass: "textEllipsis" },
                                      [
                                        _vm._v(
                                          "\n                  发起时间：" +
                                            _vm._s(
                                              _vm._f("formatDateHM")(
                                                row.createTime
                                              )
                                            ) +
                                            "\n                  "
                                        ),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content: "由钉钉发起的",
                                              placement: "bottom-start"
                                            }
                                          },
                                          [
                                            row.fromDingTalk &&
                                            row.fromDingTalk == 1 &&
                                            !_vm.isInDingTalk
                                              ? _c("img", {
                                                  attrs: {
                                                    src:
                                                      "/images/icon/dingIcon.png",
                                                    alt: "钉钉",
                                                    width: "20px"
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                        ),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content: "由WEB端发起的",
                                              placement: "bottom-start"
                                            }
                                          },
                                          [
                                            !row.fromDingTalk &&
                                            _vm.isInDingTalk
                                              ? _c(
                                                  "el-tag",
                                                  {
                                                    attrs: {
                                                      type: "danger",
                                                      size: "small"
                                                    }
                                                  },
                                                  [_vm._v("WEB")]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2511115275
                    )
                  }),
                  _c("el-table-column", {
                    attrs: { label: "签署方", "min-width": "250" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              ["5", "6"].includes(_vm.$route.query.signStatus)
                                ? [
                                    row.approval
                                      ? _c(
                                          "div",
                                          [
                                            !row.flowType
                                              ? _c(
                                                  "el-tooltip",
                                                  {
                                                    attrs: {
                                                      placement: "bottom-start"
                                                    }
                                                  },
                                                  [
                                                    _vm._l(
                                                      row.approval
                                                        ? row.approval
                                                            .signInfoVOS
                                                        : [],
                                                      function(item, i) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: i,
                                                            staticStyle: {
                                                              display: "flex",
                                                              "align-items":
                                                                "center",
                                                              "padding-bottom":
                                                                "5px"
                                                            },
                                                            attrs: {
                                                              slot: "content"
                                                            },
                                                            slot: "content"
                                                          },
                                                          [
                                                            item.orderNum &&
                                                            item.orderNum >= 1
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle: {
                                                                      display:
                                                                        "block",
                                                                      width:
                                                                        "13px",
                                                                      height:
                                                                        "13px",
                                                                      "border-radius":
                                                                        "50%",
                                                                      color:
                                                                        "#ffffff",
                                                                      border:
                                                                        "1px solid #ffffff",
                                                                      "text-align":
                                                                        "center",
                                                                      "line-height":
                                                                        "13px",
                                                                      "font-size":
                                                                        "12px"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.orderNum
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle: {
                                                                      color:
                                                                        "#ffffff"
                                                                    }
                                                                  },
                                                                  [_vm._v("·")]
                                                                ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  color:
                                                                    "#ffffff",
                                                                  "font-size":
                                                                    "12px"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        【" +
                                                                    _vm._s(
                                                                      item.signStatus ===
                                                                        0 ||
                                                                        item.signStatus ===
                                                                          -1
                                                                        ? "未签署"
                                                                        : item.signStatus ===
                                                                          1
                                                                        ? "已签署"
                                                                        : "已拒签"
                                                                    ) +
                                                                    "】\n                      "
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticStyle: {
                                                                  color:
                                                                    "#ffffff",
                                                                  "font-size":
                                                                    "12px"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.signatoryFullName
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    _c(
                                                      "div",
                                                      [
                                                        _vm._l(
                                                          row.approval
                                                            ? row.approval
                                                                .signInfoVOS
                                                            : [],
                                                          function(
                                                            chItem,
                                                            chIndex
                                                          ) {
                                                            return _c(
                                                              "p",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "show",
                                                                    rawName:
                                                                      "v-show",
                                                                    value:
                                                                      chIndex <
                                                                      3,
                                                                    expression:
                                                                      "chIndex < 3"
                                                                  }
                                                                ],
                                                                key: chIndex,
                                                                staticClass:
                                                                  "textEllipsis"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      chItem.signatoryFullName
                                                                    ) +
                                                                    "\n                      "
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        row.approval &&
                                                        row.approval.signInfoVOS
                                                          .length > 3
                                                          ? _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "textEllipsis"
                                                              },
                                                              [_vm._v("···")]
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      2
                                                    )
                                                  ],
                                                  2
                                                )
                                              : _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      row.approval.signatoryName
                                                    )
                                                  )
                                                ])
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                : [
                                    _c(
                                      "el-tooltip",
                                      { attrs: { placement: "bottom-start" } },
                                      [
                                        _vm._l(row.signInfoVOS, function(
                                          item,
                                          i
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: i,
                                              staticStyle: {
                                                display: "flex",
                                                "align-items": "center",
                                                "padding-bottom": "5px"
                                              },
                                              attrs: { slot: "content" },
                                              slot: "content"
                                            },
                                            [
                                              item.orderNum &&
                                              item.orderNum >= 1
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        display: "block",
                                                        width: "13px",
                                                        height: "13px",
                                                        "border-radius": "50%",
                                                        color: "#ffffff",
                                                        border:
                                                          "1px solid #ffffff",
                                                        "text-align": "center",
                                                        "line-height": "13px",
                                                        "font-size": "12px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.orderNum)
                                                      )
                                                    ]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "#ffffff"
                                                      }
                                                    },
                                                    [_vm._v("·")]
                                                  ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    color: "#ffffff",
                                                    "font-size": "12px"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      【" +
                                                      _vm._s(
                                                        item.signStatus === 0 ||
                                                          item.signStatus === -1
                                                          ? "未签署"
                                                          : item.signStatus ===
                                                            1
                                                          ? "已签署"
                                                          : "已拒签"
                                                      ) +
                                                      "】\n                    "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    color: "#ffffff",
                                                    "font-size": "12px"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.signatoryFullName
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        _c(
                                          "div",
                                          [
                                            _vm._l(row.signInfoVOS, function(
                                              chItem,
                                              chIndex
                                            ) {
                                              return _c(
                                                "p",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: chIndex < 3,
                                                      expression: "chIndex < 3"
                                                    }
                                                  ],
                                                  key: chIndex,
                                                  staticClass: "textEllipsis"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        chItem.signatoryFullName
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              )
                                            }),
                                            row.signInfoVOS &&
                                            row.signInfoVOS.length > 3
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass: "textEllipsis"
                                                  },
                                                  [_vm._v("···")]
                                                )
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      ],
                                      2
                                    )
                                  ]
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1116525226
                    )
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "状态",
                      width: "100",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              ["5", "6"].includes(_vm.$route.query.signStatus)
                                ? [
                                    row.approval
                                      ? _c(
                                          "div",
                                          [
                                            !row.flowType
                                              ? [
                                                  row.approval.signStatus === -3
                                                    ? [
                                                        row.approval
                                                          .selfApprove === 1
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "red"
                                                              },
                                                              [_vm._v("待我审")]
                                                            )
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "blue"
                                                              },
                                                              [_vm._v("待ta审")]
                                                            )
                                                      ]
                                                    : row.approval
                                                        .signStatus === -4
                                                    ? [
                                                        _c("p", [
                                                          _vm._v("审批驳回")
                                                        ])
                                                      ]
                                                    : row.approval
                                                        .signStatus === 0
                                                    ? [
                                                        row.approval
                                                          .selfSign === 1
                                                          ? _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "red"
                                                              },
                                                              [_vm._v("待我签")]
                                                            )
                                                          : _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "blue"
                                                              },
                                                              [_vm._v("待ta签")]
                                                            )
                                                      ]
                                                    : row.approval
                                                        .signStatus === 1
                                                    ? [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "green"
                                                          },
                                                          [_vm._v("已完成")]
                                                        )
                                                      ]
                                                    : row.approval
                                                        .signStatus === 2
                                                    ? [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "orange"
                                                          },
                                                          [_vm._v("已拒签")]
                                                        )
                                                      ]
                                                    : row.approval
                                                        .signStatus === 4
                                                    ? [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "orange"
                                                          },
                                                          [_vm._v("已作废")]
                                                        )
                                                      ]
                                                    : row.approval
                                                        .signStatus === -5
                                                    ? [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "grey"
                                                          },
                                                          [_vm._v("已撤销")]
                                                        )
                                                      ]
                                                    : row.approval
                                                        .signStatus === -6
                                                    ? [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "grey"
                                                          },
                                                          [_vm._v("已过期")]
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ]
                                              : [
                                                  _c(
                                                    "span",
                                                    {
                                                      class: _vm.classFn(
                                                        row.approval
                                                      )
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.statuShowFn(
                                                            row.approval
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  ]
                                : [
                                    row.signStatus === -3
                                      ? [
                                          row.selfApprove === 1
                                            ? _c(
                                                "span",
                                                { staticClass: "red" },
                                                [_vm._v("待我审")]
                                              )
                                            : _c(
                                                "span",
                                                { staticClass: "blue" },
                                                [_vm._v("待ta审")]
                                              )
                                        ]
                                      : row.signStatus === -4
                                      ? [_c("p", [_vm._v("审批驳回")])]
                                      : row.signStatus === 0
                                      ? [
                                          row.selfSign === 1
                                            ? _c("p", { staticClass: "red" }, [
                                                _vm._v("待我签")
                                              ])
                                            : _c("p", { staticClass: "blue" }, [
                                                _vm._v("待ta签")
                                              ])
                                        ]
                                      : row.signStatus === 1
                                      ? [
                                          _c("span", { staticClass: "green" }, [
                                            _vm._v("已完成")
                                          ])
                                        ]
                                      : row.signStatus === 2
                                      ? [
                                          _c(
                                            "span",
                                            { staticClass: "orange" },
                                            [_vm._v("已拒签")]
                                          )
                                        ]
                                      : row.signStatus === 4
                                      ? [
                                          _c(
                                            "span",
                                            { staticClass: "orange" },
                                            [_vm._v("已作废")]
                                          )
                                        ]
                                      : row.signStatus === -5
                                      ? [
                                          _c("span", { staticClass: "grey" }, [
                                            _vm._v("已撤销")
                                          ])
                                        ]
                                      : row.signStatus === -6
                                      ? [
                                          _c("span", { staticClass: "grey" }, [
                                            _vm._v("已过期")
                                          ])
                                        ]
                                      : _vm._e()
                                  ]
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2303805484
                    )
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "130px" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return _vm.APLOShow(row)
                              ? [
                                  ["5", "6"].includes(
                                    _vm.$route.query.signStatus
                                  )
                                    ? [
                                        row.approval
                                          ? _c(
                                              "div",
                                              [
                                                !row.flowType
                                                  ? [
                                                      _vm.showOptions(
                                                        row.approval
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "operate-box pointer"
                                                            },
                                                            [
                                                              _vm.$route.query
                                                                .signStatus ==
                                                                5 &&
                                                              row.approval
                                                                .signStatus ===
                                                                -3 &&
                                                                row.approval
                                                                  .selfApprove !==
                                                                  1
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "color-success",
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleproceInfo(
                                                                            row
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "审批详情"
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm.isInDingTalk
                                                                ? [
                                                                    _vm.$route
                                                                      .query
                                                                      .signStatus ==
                                                                      5 &&
                                                                    row.approval
                                                                      .signStatus ===
                                                                      -3 &&
                                                                      row
                                                                        .approval
                                                                        .selfApprove ==
                                                                        1
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "color-success",
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.toApprove(
                                                                                  row.approval
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "审批"
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                : _vm._e(),
                                                              [
                                                                row.approval
                                                                  .signStatus !==
                                                                1
                                                                  ? _c(
                                                                      "corp-handles",
                                                                      {
                                                                        ref:
                                                                          "handlesComp",
                                                                        attrs: {
                                                                          rowData:
                                                                            row.approval,
                                                                          applyType:
                                                                            "signList"
                                                                        },
                                                                        on: {
                                                                          setCSDialogData:
                                                                            _vm.onSetCSDialogData,
                                                                          setSSDialogData:
                                                                            _vm.onSetSSDialogData,
                                                                          resetList:
                                                                            _vm.getSignLists
                                                                        }
                                                                      }
                                                                    )
                                                                  : _vm._e(),
                                                                row.approval
                                                                  .signStatus ===
                                                                1
                                                                  ? [
                                                                      _c(
                                                                        "existing-evidence",
                                                                        {
                                                                          attrs: {
                                                                            rowData:
                                                                              row.approval
                                                                          },
                                                                          on: {
                                                                            copyTextToQueryEmit:
                                                                              _vm.copyTextToQuery
                                                                          }
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "el-dropdown",
                                                                        {
                                                                          attrs: {
                                                                            trigger:
                                                                              "click"
                                                                          },
                                                                          on: {
                                                                            "visible-change": function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.visiChange(
                                                                                $event,
                                                                                row
                                                                                  .approval
                                                                                  .applyId
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "com-normal-btn"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                      更多操作\n                      "
                                                                              ),
                                                                              _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "com-normal-btn el-icon--right",
                                                                                  class:
                                                                                    _vm
                                                                                      .visiDown
                                                                                      .status &&
                                                                                    _vm
                                                                                      .visiDown
                                                                                      .rowApplyId ==
                                                                                      row
                                                                                        .approval
                                                                                        .applyId
                                                                                      ? "el-icon-caret-top"
                                                                                      : "el-icon-caret-bottom"
                                                                                }
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "el-dropdown-menu",
                                                                            {
                                                                              staticStyle: {
                                                                                "background-color":
                                                                                  "#f5f6f6"
                                                                              },
                                                                              attrs: {
                                                                                slot:
                                                                                  "dropdown"
                                                                              },
                                                                              slot:
                                                                                "dropdown"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "more-button",
                                                                                {
                                                                                  attrs: {
                                                                                    rowData:
                                                                                      row.approval,
                                                                                    showMoreBtn: true,
                                                                                    Cancancel: true
                                                                                  },
                                                                                  on: {
                                                                                    btnMethodFn:
                                                                                      _vm.openLYDialog
                                                                                  }
                                                                                }
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ]
                                                                  : _vm._e()
                                                              ]
                                                            ],
                                                            2
                                                          )
                                                        : _vm._e(),
                                                      row.approval
                                                        .applySignStatus ===
                                                        4 ||
                                                      row.approval
                                                        .signStatus === 4
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "com-normal-btn",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.toApplyDetail(
                                                                    row.approval
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "查看作废协议"
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  : [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "operation_btn",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.sealHandleproceInfo(
                                                                row
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("审批详情")]
                                                      ),
                                                      _vm.isInDingTalk
                                                        ? [
                                                            row.approval
                                                              .flowStatus ===
                                                              0 &&
                                                            row.approval
                                                              .selfApprove &&
                                                            row.approval
                                                              .selfApprove == 1
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "operation_btn",
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.signApproveHandle(
                                                                          row.approval
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "审批"
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        : [
                                                            row.approval
                                                              .selfApprove
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "operate-box pointer"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "operation_btn",
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.approveSubmitFn(
                                                                              1,
                                                                              row.approval
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "同意"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "operation_btn",
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.approveSubmitFn(
                                                                              2,
                                                                              row.approval
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "拒绝"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                    ]
                                              ],
                                              2
                                            )
                                          : _vm._e()
                                      ]
                                    : [
                                        _vm.showOptions(row)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "operate-box pointer"
                                              },
                                              [
                                                _vm.$route.query.signStatus ==
                                                  5 &&
                                                row.signStatus === -3 &&
                                                  row.selfApprove !== 1
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "color-success",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.handleproceInfo(
                                                              row
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("审批详情")]
                                                    )
                                                  : _vm._e(),
                                                _vm.isInDingTalk
                                                  ? [
                                                      _vm.$route.query
                                                        .signStatus == 5 &&
                                                      row.signStatus === -3 &&
                                                        row.selfApprove == 1
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "color-success",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.toApprove(
                                                                    row
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [_vm._v("审批")]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  : _vm._e(),
                                                [
                                                  row.signStatus !== 1
                                                    ? _c("corp-handles", {
                                                        ref: "handlesComp",
                                                        attrs: {
                                                          rowData: row,
                                                          applyType: "signList"
                                                        },
                                                        on: {
                                                          setCSDialogData:
                                                            _vm.onSetCSDialogData,
                                                          setSSDialogData:
                                                            _vm.onSetSSDialogData,
                                                          resetList:
                                                            _vm.getSignLists
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  row.signStatus === 1
                                                    ? [
                                                        _c(
                                                          "existing-evidence",
                                                          {
                                                            attrs: {
                                                              rowData: row
                                                            },
                                                            on: {
                                                              copyTextToQueryEmit:
                                                                _vm.copyTextToQuery
                                                            }
                                                          }
                                                        ),
                                                        _c(
                                                          "el-dropdown",
                                                          {
                                                            attrs: {
                                                              trigger: "click"
                                                            },
                                                            on: {
                                                              "visible-change": function(
                                                                $event
                                                              ) {
                                                                return _vm.visiChange(
                                                                  $event,
                                                                  row.applyId
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "com-normal-btn"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                      更多操作\n                      "
                                                                ),
                                                                _c("i", {
                                                                  staticClass:
                                                                    "com-normal-btn el-icon--right",
                                                                  class:
                                                                    _vm.visiDown
                                                                      .status &&
                                                                    _vm.visiDown
                                                                      .rowApplyId ==
                                                                      row.applyId
                                                                      ? "el-icon-caret-top"
                                                                      : "el-icon-caret-bottom"
                                                                })
                                                              ]
                                                            ),
                                                            _c(
                                                              "el-dropdown-menu",
                                                              {
                                                                staticStyle: {
                                                                  "background-color":
                                                                    "#f5f6f6"
                                                                },
                                                                attrs: {
                                                                  slot:
                                                                    "dropdown"
                                                                },
                                                                slot: "dropdown"
                                                              },
                                                              [
                                                                _c(
                                                                  "more-button",
                                                                  {
                                                                    attrs: {
                                                                      rowData: row,
                                                                      showMoreBtn: true,
                                                                      Cancancel: true
                                                                    },
                                                                    on: {
                                                                      btnMethodFn:
                                                                        _vm.openLYDialog
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ]
                                              ],
                                              2
                                            )
                                          : _vm._e(),
                                        row.applySignStatus === 4 ||
                                        row.signStatus === 4
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "com-normal-btn",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.toApplyDetail(
                                                      row
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("查看作废协议")]
                                            )
                                          : _vm._e()
                                      ]
                                ]
                              : undefined
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                ],
                _c("no-data", {
                  attrs: { slot: "empty", text: "暂无数据" },
                  slot: "empty"
                })
              ],
              2
            ),
            false &&
            _vm.batchLength &&
            (!_vm.$route.query.signStatus || _vm.$route.query.signStatus !== 2)
              ? _c("div", { staticClass: "bulkOperation" }, [
                  _vm._v(
                    "\n        已选" +
                      _vm._s(_vm.batchLength) +
                      "份文件\n        "
                  )
                ])
              : _vm._e(),
            _c(
              "el-row",
              {
                staticClass: "pageation row",
                style: { marginLeft: !_vm.$route.query.signStatus ? "70px" : 0 }
              },
              [
                _c(
                  "el-col",
                  { attrs: { span: 7 } },
                  [
                    ![2, 4, 5].includes(+_vm.$route.query.signStatus)
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: { click: _vm.batchDown }
                          },
                          [_vm._v("下载")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.emitFn("saveToDir")
                          }
                        }
                      },
                      [_vm._v("归档")]
                    ),
                    !_vm.$route.query.ccToMe
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: {
                              click: function($event) {
                                return _vm.selectCcUserFn()
                              }
                            }
                          },
                          [_vm._v("抄送")]
                        )
                      : _vm._e(),
                    _vm.$route.query.signStatus == 4
                      ? _c(
                          "el-tooltip",
                          { attrs: { effect: "dark" } },
                          [
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  width: "200px",
                                  "line-height": "1.5"
                                },
                                attrs: { slot: "content" },
                                slot: "content"
                              },
                              [
                                _vm._v(
                                  "\n              批量签署规则：\n              "
                                ),
                                _c("br"),
                                _vm._v(
                                  "1、当前签署方必须有固定签章位置\n              "
                                ),
                                _c("br"),
                                _vm._v(
                                  "2、当前签署方不需要进行身份认证\n              "
                                ),
                                _c("br"),
                                _vm._v(
                                  "3、当前签署方不包含强制阅读、强制现场\n              "
                                ),
                                _c("br"),
                                _vm._v(
                                  "4、待ta签的合同不能进行批量签署\n            "
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { size: "small" },
                                on: { click: _vm.batchSign }
                              },
                              [_vm._v("批量签署")]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { staticClass: "page-flex-end", attrs: { span: 17 } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        small: "",
                        "current-page": _vm.screenParme.itemPage,
                        "pager-count": 5,
                        "page-sizes": [10, 20, 50, 100],
                        "page-size": _vm.screenParme.pageSize,
                        layout: "sizes, prev, pager, next, total",
                        total: _vm.screenParme.pageTotal
                      },
                      on: {
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange
                      }
                    }),
                    _c("el-go", {
                      attrs: {
                        "page-size": _vm.screenParme.pageSize,
                        total: _vm.screenParme.pageTotal
                      },
                      on: { "current-change": _vm.handleCurrentChange }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        : _vm._e(),
      _vm.navTabVal === "corpCcToMe" ? [_c("signListNew")] : _vm._e(),
      _vm.navTabVal === "mySendTo" ? [_c("applyListNew")] : _vm._e(),
      _c("tag-manage", {
        ref: "tagManage",
        attrs: { isCrop: true },
        on: { close: _vm.getTagList, refresh: _vm.getSignLists }
      }),
      _vm.cSDialogVisible
        ? _c("certiServiceDialog", {
            attrs: {
              dialogVisible: _vm.cSDialogVisible,
              listType: "corpList",
              param: _vm.cSDialogData
            },
            on: { setCSDialogData: _vm.onSetCSDialogData }
          })
        : _vm._e(),
      _vm.sSDialogVisible
        ? _c("selectSubjectDialog", {
            attrs: {
              dialogVisible: _vm.sSDialogVisible,
              param: _vm.sSDialogData
            },
            on: { setSSDialogData: _vm.onSetSSDialogData }
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          staticClass: "ly-info",
          attrs: {
            title: "履约文件",
            visible: _vm.lYDialogVisible,
            width: "850px"
          },
          on: {
            "update:visible": function($event) {
              _vm.lYDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-tabs",
            {
              staticClass: "ly-mask",
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _c("el-tab-pane", { attrs: { label: "上传原文件", name: "1" } }, [
                _c("p", { staticClass: "tips" }, [
                  _vm._v(
                    "支持常见图片、文档、视频、音频、压缩包格式，上传后会保存原文件，单个文件大小不超过30MB"
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "box-wrap" },
                  [
                    _c("div", { staticClass: "temone add" }, [
                      _c("span", { staticClass: "el-icon-plus" }),
                      _c("input", {
                        ref: "referenceUpload",
                        staticClass: "file-ipt",
                        attrs: { type: "file" },
                        on: { change: _vm.handleInputChange }
                      })
                    ]),
                    _vm._l(_vm.lYDialogData, function(item, idx) {
                      return _c("div", { key: idx, staticClass: "temone" }, [
                        _c("div", { staticClass: "t-box" }, [
                          _c("img", {
                            staticClass: "y-img",
                            attrs: { src: "/images/web/file-icon.png" }
                          }),
                          _c("div", { staticClass: "msk" }, [
                            _c("span", { staticClass: "des" }, [
                              _vm._v(
                                "上传人：" +
                                  _vm._s(item.userName) +
                                  " -" +
                                  _vm._s(item.accountName)
                              )
                            ])
                          ])
                        ]),
                        _c("div", { staticClass: "a-btn" }, [
                          _c(
                            "a",
                            {
                              staticClass: "has-hover",
                              attrs: { href: _vm.downloadLYFile(item.file) }
                            },
                            [_vm._v("下载")]
                          ),
                          _vm.isDoc(item)
                            ? _c(
                                "a",
                                {
                                  staticClass: "has-hover",
                                  on: {
                                    click: function($event) {
                                      return _vm.previewDoc(item)
                                    }
                                  }
                                },
                                [_vm._v("预览")]
                              )
                            : _vm._e(),
                          _vm.isVideoOrImg(item)
                            ? _c(
                                "a",
                                {
                                  staticClass: "has-hover",
                                  on: {
                                    click: function($event) {
                                      return _vm.previewVideOrImg(item)
                                    }
                                  }
                                },
                                [_vm._v("预览")]
                              )
                            : _vm._e(),
                          item.canDelete
                            ? _c(
                                "a",
                                {
                                  staticClass: "has-hover",
                                  on: {
                                    click: function($event) {
                                      return _vm.delLYFile(item)
                                    }
                                  }
                                },
                                [_vm._v("删除")]
                              )
                            : _vm._e(),
                          _c("a", { staticClass: "no-hover" }, [
                            _vm._v(_vm._s(item.fileName))
                          ])
                        ])
                      ])
                    })
                  ],
                  2
                )
              ]),
              _c(
                "el-tab-pane",
                { attrs: { label: "上传文件哈希", name: "2" } },
                [
                  _c("p", { staticClass: "tips" }, [
                    _vm._v(
                      "格式没有限制，仅保存上传文件的特征值（哈希），不对文件本身做保存，单个文件大小不超过500M"
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "box-wrap" },
                    [
                      _c("div", { staticClass: "temone add" }, [
                        _c("span", { staticClass: "el-icon-plus" }),
                        _c("input", {
                          ref: "referenceUpload1",
                          staticClass: "file-ipt",
                          attrs: { type: "file" },
                          on: { change: _vm.handleInputChange }
                        })
                      ]),
                      _vm._l(_vm.lYDialogData, function(item, idx) {
                        return _c("div", { key: idx, staticClass: "temone" }, [
                          _c("div", { staticClass: "t-box" }, [
                            _c("img", {
                              staticClass: "y-img",
                              attrs: { src: "/images/web/hash-icon.png" }
                            }),
                            _c("div", { staticClass: "msk" }, [
                              _c("span", { staticClass: "des" }, [
                                _vm._v(
                                  "上传人：" +
                                    _vm._s(item.userName) +
                                    " -" +
                                    _vm._s(item.accountName)
                                )
                              ]),
                              _c("br"),
                              _c(
                                "span",
                                {
                                  staticClass: "des",
                                  staticStyle: { margin: "0" }
                                },
                                [_vm._v("备案号：" + _vm._s(item.presId))]
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "a-btn" }, [
                            _c(
                              "a",
                              {
                                staticClass: "has-hover",
                                on: {
                                  click: function($event) {
                                    return _vm.validLYFile(item)
                                  }
                                }
                              },
                              [_vm._v("验证")]
                            ),
                            item.canDelete
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "has-hover",
                                    on: {
                                      click: function($event) {
                                        return _vm.delLYFile(item)
                                      }
                                    }
                                  },
                                  [_vm._v("删除")]
                                )
                              : _vm._e(),
                            _c("a", { staticClass: "no-hover" }, [
                              _vm._v(_vm._s(item.fileName))
                            ])
                          ])
                        ])
                      })
                    ],
                    2
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("span", { staticClass: "num" }, [
                _vm._v("\n          文件数：\n          "),
                _c("label", [_vm._v(_vm._s(_vm.lYDialogData.length))]),
                _vm._v("个\n        ")
              ]),
              _c(
                "el-button",
                {
                  staticClass: "cancel-btn",
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function($event) {
                      _vm.lYDialogVisible = false
                    }
                  }
                },
                [_vm._v("关闭")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("ViewFilesToDoc", {
        attrs: {
          visibleShow: _vm.visibleShowEnclosureDoc,
          enclosurePreviewNumItem: _vm.enclosurePreviewNumItem
        },
        on: { setViewFilesToDocDialogData: _vm.onSetViewFilesToDocDialogData }
      }),
      _c("ViewFilesToImg", {
        staticStyle: { "text-align": "center" },
        attrs: {
          visibleShow: _vm.visibleShowEnclosure,
          isRefresh: _vm.isRefresh,
          enclosurePreviewNumItem: _vm.enclosurePreviewNumItem,
          imgList: _vm.getEnclosureImgList
        },
        on: { setViewFilesToImgDialogData: _vm.onSetViewFilesToImgDialogData }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.nodeQueryVisible,
            width: "800px",
            "custom-class": "data-dialog",
            "destroy-on-close": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.nodeQueryVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "node_header",
              attrs: { slot: "title" },
              slot: "title"
            },
            [_vm._v("保全链节点查询")]
          ),
          _c("p", { staticStyle: { padding: "10px" } }, [
            _vm._v("当前合同备案号：" + _vm._s(_vm.vpresId))
          ]),
          _c("node-query", { attrs: { vpresId: _vm.vpresId } })
        ],
        1
      ),
      _c("selectCcUser", {
        ref: "selectCcUserRef",
        attrs: { applyNosArr: _vm.applyNosArr },
        on: { clearListFn: _vm.clearListFn }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "系统提示",
            visible: _vm.multiBatchDialogVisible,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.multiBatchDialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "batch-tips" }, [
            _c("p", [
              _c("i", {
                staticClass: "el-icon-info",
                staticStyle: { "margin-right": "10px", "font-size": "20px" }
              }),
              _vm._v(
                "\n          确定使用以下印章，对 “" +
                  _vm._s(_vm.batchContractName) +
                  "” 等\n          " +
                  _vm._s(_vm.signInfoIdsLength) +
                  "\n          份文件中所有签章位置进行盖章（文件需要手写签字请勿使用此功能）？\n        "
              )
            ]),
            _c("p", [_vm._v("若印章使用时需要进行用印审批，不支持批量签署。")]),
            _c(
              "div",
              { staticClass: "temone-box" },
              _vm._l(_vm.chapterList, function(item, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass: "temone",
                    staticStyle: { margin: "10px" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "t-box",
                        class: {
                          "active-chap":
                            _vm.checkChapter &&
                            _vm.checkChapter.corpSealId === item.corpSealId
                        },
                        on: {
                          click: function($event) {
                            return _vm.checkUseChap(item)
                          }
                        }
                      },
                      [
                        item.hasOwnProperty("signUrl")
                          ? [
                              _c("img", {
                                staticClass: "y-img",
                                attrs: { src: item.signUrl }
                              })
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _c("p", [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            item.hasOwnProperty("signUrl")
                              ? item.sealName + "(ID:" + item.corpSealId + ")"
                              : "系统图形章"
                          ) +
                          "\n            "
                      )
                    ])
                  ]
                )
              }),
              0
            )
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { color: "#1b1b1b", background: "#fff" },
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      _vm.multiBatchDialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.batchSignAll }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      ),
      _c("approval-info-pup", {
        attrs: { proceVisi: _vm.proceVisi, approvalInof: _vm.approvalInof },
        on: { close: _vm.handleClose }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogAuditRefuseVisible,
            title: _vm.refuseModel.flowStatus === 2 ? "拒绝原因" : "审批意见",
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogAuditRefuseVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "div",
                  { staticStyle: { position: "relative" } },
                  [
                    _c("el-input", {
                      ref: "textareaReason",
                      attrs: {
                        type: "textarea",
                        rows: "5",
                        resize: "none",
                        autofocus: true,
                        size: "small",
                        maxlength: 100,
                        placeholder:
                          _vm.refuseModel.flowStatus === 2
                            ? "请输入拒绝原因"
                            : "请输入审批意见"
                      },
                      model: {
                        value: _vm.refuseModel.reason,
                        callback: function($$v) {
                          _vm.$set(_vm.refuseModel, "reason", $$v)
                        },
                        expression: "refuseModel.reason"
                      }
                    }),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          position: "absolute",
                          bottom: "10px",
                          right: "10px",
                          color: "red"
                        }
                      },
                      [_vm._v(_vm._s(_vm.refuseModel.reason.length) + "/100")]
                    )
                  ],
                  1
                )
              ]),
              _c(
                "el-col",
                { staticStyle: { height: "24px" }, attrs: { span: 24 } },
                [
                  _vm.refuseModel.errorMessage
                    ? _c("p", { staticStyle: { color: "red" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.refuseModel.errorMessage) +
                            "\n          "
                        )
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          ),
          _c(
            "p",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      _vm.dialogAuditRefuseVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { type: "danger", size: "small" },
                  on: {
                    click: function($event) {
                      return _vm.clickHandleRefuseSubmit()
                    }
                  }
                },
                [_vm._v("提交")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11b17913", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11b17913","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/corp/signInfo/signList.vue
// module id = 91Aj
// module chunks = 27